export class Interval {
  start: number
  end: number
    
  constructor(start: number, end: number) {
    this.start = start
    this.end = end
  }
}

export class Intervals {
  public static getIntervalsDuration(intervals: Array<Interval>): number {
    let duration = 0
    intervals.forEach((i: Interval) => {
      duration += i.end - i.start
    })
    return +duration.toFixed(2)
  }
  
  public static getNonOverlappingIntervals(intervals: Array<Interval>): Array<Interval> {
    if (intervals.length <= 1) {
      return intervals
    }
    
    const localIntervals = [...intervals]
    localIntervals.sort((a, b) => a.start - b.start)
    const result = new Array<Interval>()
    let newInterval = new Interval(localIntervals[0].start, localIntervals[0].end)
    result.push(newInterval)
  
    for (let i = 0; i < localIntervals.length; i++) {
      if (localIntervals[i].start <= newInterval.end)
        newInterval.end = Math.max(newInterval.end, localIntervals[i].end)
      else {
        newInterval = localIntervals[i]
        result.push(newInterval)
      }
    }
    return result
  }
}

export interface IntervalsModel {
  intervals: Array<Interval>
  objectDuration: number
}

